import React from 'react';

import styled from '@emotion/styled';

import DetailedTransactionRow from './TransactionRow/DetailedTransactionRow';

import { DetailedTransaction } from '../data';

interface Props {
  transactions: DetailedTransaction[];
}

export const ResponsiveTable = styled.table`
  background: white;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  thead,
  tbody,
  thead tr {
    display: block;
  }

  td,
  th {
    border-bottom: none;
    padding: 0;
  }
`;

const TransactionsTable: React.FC<React.PropsWithChildren<Props>> = ({ transactions }) => {
  return (
    <ResponsiveTable>
      <tbody>
        {transactions.map((txn, index) => {
          const isLast = index === transactions.length - 1;

          return <DetailedTransactionRow key={txn.id} shouldDisplayBottomBorder={!isLast} {...txn} />;
        })}
      </tbody>
    </ResponsiveTable>
  );
};

export default TransactionsTable;
